import React from 'react';
import {
  BrowserRouter, Redirect, Switch,
} from 'react-router-dom';
import { routes } from '@constants';
import {
  MenuCategories,
  MenuItems,
  Login,
  MenuItemDetails,
  CategoryProcess,
  SubcategoryProcess,
  CategoriesOrder,
  ItemProcess,
  SizeProcess,
  OptionsList,
  OptionProcess,
  AvailabilitiesList,
  Scheduling,
  Reservations,
  BookingWidget,
} from '@pages';
import AuthorizedRoute from '../AuthorizedRoute';
import UnauthorizedRoute from '../UnauthorizedRoute';
import { Route } from 'react-router-dom';

const Router = () => (
  <BrowserRouter>
    <Switch>
      <UnauthorizedRoute exact path={routes.login}>
        <Login />
      </UnauthorizedRoute>
      <AuthorizedRoute exact path={routes.menu}>
        <MenuCategories />
      </AuthorizedRoute>
      <AuthorizedRoute exact path={routes.menuItems}>
        <MenuItems />
      </AuthorizedRoute>
      <AuthorizedRoute exact path={routes.menuItemDetails}>
        <MenuItemDetails />
      </AuthorizedRoute>
      <AuthorizedRoute exact path={routes.categoryEdit}>
        <CategoryProcess />
      </AuthorizedRoute>
      <AuthorizedRoute exact path={routes.subcategoryEdit}>
        <SubcategoryProcess />
      </AuthorizedRoute>
      <AuthorizedRoute exact path={routes.categoriesOrder}>
        <CategoriesOrder />
      </AuthorizedRoute>
      <AuthorizedRoute exact path={routes.itemEdit}>
        <ItemProcess />
      </AuthorizedRoute>
      <AuthorizedRoute exact path={routes.sizeEdit}>
        <SizeProcess />
      </AuthorizedRoute>
      <AuthorizedRoute exact path={routes.optionsList}>
        <OptionsList />
      </AuthorizedRoute>
      <AuthorizedRoute exact path={routes.optionEdit}>
        <OptionProcess />
      </AuthorizedRoute>
      <AuthorizedRoute exact path={routes.availabilitiesList}>
        <AvailabilitiesList />
      </AuthorizedRoute>
      <AuthorizedRoute exact path={routes.scheduling}>
        <Scheduling />
      </AuthorizedRoute>
      <AuthorizedRoute exact path={routes.reservations}>
        <Reservations />
      </AuthorizedRoute>
      <Route exact path={routes.bookingWidget}>
        <BookingWidget />
      </Route>
      <Redirect to={routes.login} />
    </Switch>
  </BrowserRouter>
);

export default Router;
